/**
 * Landing Module - Konfigurasjon
 * Sentralisert konfigurasjon for landingssiden
 */

// ============================================================
// FEATURE FLAGS
// ============================================================
export const SHOW_PRICING = false; // Sett til true for å aktivere prispakker

// ============================================================
// BRAND KONFIGURASJON
// ============================================================
export const CONFIG = {
  logo: {
    src: "https://customer-assets.emergentagent.com/job_93aee804-9f94-4e5b-9dc6-d43babdb2cb7/artifacts/va1fmaf5_image.jpg",
    alt: "RettVerk Logo"
  },
  brand: {
    name: "RettVerk",
    tagline: "Norsk juridisk assistent"
  }
};

// ============================================================
// PRISPAKKER
// ============================================================
export const PRICING = [
  {
    id: 'starter_5',
    name: 'Startpakke',
    price: '29',
    period: 'engangskjøp',
    description: 'Perfekt for å prøve',
    features: ['5 dokumentanalyser', '5 svarbrev', 'Ingen abonnement', 'Gyldig i 30 dager'],
    highlight: false
  },
  {
    id: 'premium_monthly',
    name: 'Premium',
    price: '199',
    period: 'per måned',
    description: 'Ubegrenset tilgang',
    features: ['Ubegrenset dokumenter', 'Ubegrenset svarbrev', 'Barnevern-modul', 'Prioritert AI', 'E-post støtte'],
    highlight: true,
    badge: 'Mest populær'
  },
  {
    id: 'premium_yearly',
    name: 'Premium Årlig',
    price: '1990',
    period: 'per år',
    description: 'Spar 2 måneder',
    features: ['Alt i Premium', '2 måneder gratis', 'Prioritert support'],
    highlight: false,
    badge: 'Best verdi'
  }
];

// ============================================================
// ENTERPRISE CHAT STEG
// ============================================================
export const CHAT_STEPS = [
  { 
    id: 'users', 
    question: 'Hvor mange brukere trenger dere tilgang for?', 
    type: 'number', 
    placeholder: 'Antall brukere (f.eks. 15)' 
  },
  { 
    id: 'cases', 
    question: 'Hvilke typer saker jobber dere mest med?', 
    type: 'multiselect', 
    options: [
      { id: 'barnevern', label: 'Barnevernssaker' },
      { id: 'klager', label: 'Klager og vedtak' },
      { id: 'generell', label: 'Generell juridisk' },
      { id: 'annet', label: 'Annet' }
    ]
  },
  { 
    id: 'volume', 
    question: 'Omtrent hvor mange dokumenter behandler dere per måned?', 
    type: 'select', 
    options: [
      { id: '50', label: 'Under 50' },
      { id: '200', label: '50-200' },
      { id: '500', label: '200-500' },
      { id: '1000', label: 'Over 500' }
    ]
  },
  { 
    id: 'addons', 
    question: 'Trenger dere noen tilleggstjenester?', 
    type: 'multiselect', 
    options: [
      { id: 'priority_support', label: 'Prioritert support' },
      { id: 'api_access', label: 'API-tilgang' },
      { id: 'custom_training', label: 'Tilpasset opplæring' },
      { id: 'data_export', label: 'Dataeksport' }
    ]
  },
  { 
    id: 'contact', 
    question: 'Flott! For å sende tilbudet, trenger vi kontaktinfo:', 
    type: 'contact' 
  }
];
